module.exports = __webpack_public_path__ + "static/media/g_meet_icon.1769e367.svg";